import FormatQuote from "@material-ui/icons/FormatQuote";
import PropTypes from "prop-types";
import React from "react";
import withStyles from "@material-ui/core/styles/withStyles";

import Card from "components/Card/Card.jsx";
import CardBody from "components/Card/CardBody.jsx";
import CardFooter from "components/Card/CardFooter.jsx";
import centerStyle from "./center";
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";

import { cardTitle } from "assets/jss/material-dashboard-pro-react.jsx";

const styles = theme => ({
  cardTitle,
  card: {
    border: "1px solid #DDD",
    minHeight: "410px",
    [theme.breakpoints.down("sm")]: {
      minHeight: "unset",
    },
  },
  cardCategory: {
    color: "#999999",
    marginTop: "10px",
  },
  cardTestimonialDescription: {
    fontStyle: "italic",
    color: "#999999",
  },
  centeredSection: {
    ...centerStyle(theme),
    padding: "20px 0",
  },
  main: {
    backgroundColor: "white",
    color: "black",
    [theme.breakpoints.down("sm")]: {
      padding: "0",
    },
  },
  testimonialIcon: {
    marginTop: "30px",
    "& svg": {
      width: "40px",
      height: "40px",
    },
  },
});

const Testemunhos = ({ classes }) => (
  <main className={classes.main} id="testemunhos">
    <section className={classes.centeredSection}>
      <GridContainer>
        <GridItem lg={6} md={6} sm={12} xs={12} >
          <Card className={classes.card} testimonial>
            <div className={classes.testimonialIcon}>
              <FormatQuote />
            </div>
            <CardBody>
              <h5 className={classes.cardTestimonialDescription}>
                A Energy Company me ajuda muito no dia dia, tenho <strong>informações em tempo real</strong> de forma prática e objetiva.
              </h5>
            </CardBody>
            <CardFooter testimonial>
              <h4 className={classes.cardTitle}>Leonardo Lopes</h4>
              <h6 className={classes.cardCategory}>@NC Energia</h6>
            </CardFooter>
          </Card>
        </GridItem>

        <GridItem md={6} sm={12} xs={12} >
          <Card className={classes.card} testimonial>
            <div className={classes.testimonialIcon}>
              <FormatQuote />
            </div>
            <CardBody>
              <h5 className={classes.cardTestimonialDescription}>
                A Energy Company permite que eu tenha acesso a informação rápida sobre tudo relacionado ao CNPJ de qualquer cliente do mercado e traz a informação detalhada do eventual perfil do cliente se o mesmo já estiver no Mercado Livre, onde identificamos Requisito e Recurso, Lastro Média Móvel, Perfil de Contratação Sugerida calculada já com base nas medições reais e públicas do cliente na CCEE e abertura da Contabilização. Além de tudo isso, o Relatório <strong>ajuda muito na prospecção de potenciais clientes</strong> no mercado. Por tudo isso eu recomendo.
              </h5>
            </CardBody>
            <CardFooter testimonial>
              <h4 className={classes.cardTitle}>Hugo Leite</h4>
              <h6 className={classes.cardCategory}>@CPFL Energia</h6>
            </CardFooter>
          </Card>
        </GridItem>
      </GridContainer>
    </section>
  </main>
);

Testemunhos.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(Testemunhos);



// WEBPACK FOOTER //
// ./src/views/LandingPage/partials/4-testemunhos.js